import request from '@hb/sharp-request';
import requestDefault from '@/shared/utils/request';
import { newGatewayUrl } from '@/constant';
import {
  ConstractPreApply,
  ContractData,
  LoanAgreementPO,
  LoanContract,
  LoanEvidence,
  Commodity,
  ContractParamType,
  ContractSceneTypeEnum,
  AbTestContractResult,
} from './types';

// 获取电子借据内容
export const getLoanEvidence = (
  commodityId: number | string,
  orderId: string,
  userBankCardId: number | string,
): Promise<LoanEvidence> => requestDefault.postGate('f.contract.eContract', {
  commodityId,
  orderId,
  userBankCardId,
});

// 还款借款合同
export const getPayContractLoan = (params: ContractParamType): Promise<ContractData[]> => request
  .postGate<ContractData[]>('f.contract.getLoanContract', {
    ...params,
    // 接口单位是分
    amount: params.amount ? params.amount * 100 : params.amount,
  },
  { baseURL: newGatewayUrl })
  .then((data) => data.map((item) => ({
    ...item,
    isThirdUrl: true,
  })));

// 获取产品指定类型合同集合
export const getDynamicUrl = (
  params: ContractParamType,
  options: Dictionary = {},
): Promise<ContractData[]> => request
  .postGate<ContractData[]>('f.contract.mgetCommodity', {
    ...params,
    // 接口单位是分
    amount: params.amount ? params.amount * 100 : params.amount,
  }, { ...options, baseURL: newGatewayUrl })
  .then((data) => data.map((item) => ({
    ...item,
    isThirdUrl: true,
  })));

// 新银河授信协议
export const newYhConstract = (params: {
  commodityId: number;
  loanOrderId: string;
  repayStatus: string;
}): Promise<ConstractPreApply> => request.postGate(
  'f.contract.credit.agreement',
  { ...params },
  { baseURL: newGatewayUrl },
);
// 新银河借款合同协议
export const loanAgreementParms = (
  params: LoanContract,
): Promise<LoanAgreementPO> => request.postGate(
  'f.contract.loan.agreement',
  { ...params },
  { baseURL: newGatewayUrl, showLoading: undefined },
);

// 根据Commodity批量获取合同协议
export const getAgreementsByCommodities = (
  params: ContractParamType & {commodityIds: number[]},
  showLoading = false,
): Promise<Commodity[]> => requestDefault.postGate(
  'f.contract.batch.mgetCommodity',
  {
    /** 新代码8180渠道请求协议可能会获取到creditRouteChannel（征信路由）字段
     * 入参此参数可区分用户请求代码的新老版本（万分之3用户访问老版本）
     * 稳定访问新代码后可删除
     */
    getCreditRouteChannel: true,
    ...params,
  },
  showLoading
    ? { abortXhr: true }
    : { showLoading: undefined, abortXhr: true },
);

/** 根据Commodity批量获取贷超半流程合同协议
 * ⚠️接口没有返回productName和productIcon，目前授信流程也没依赖这两个字段做逻辑
 * 后续如需依赖，需要让后端返回
 */
export const getDcContractList = (
  commodityIds: number[],
): Promise<Commodity[]> => requestDefault.postGate(
  'f.dc.contract.list',
  { commoditys: commodityIds },
  {
    showLoading: undefined,
  },
);

/**
 * 获取协议阅读协议灰度规则命中结果
 * @yapi https://yapi.hellobike.cn/project/3415/interface/api/329085
 * * */
export const getAbTestContract = (
  sceneType: ContractSceneTypeEnum,
  productIdList: string[] | number[],
): Promise<AbTestContractResult> => requestDefault.postGate(
  'f.common.abTest.contract',
  {
    sceneType,
    productIdList,
  },
);

const ContractApi = {
  contractInfo: getLoanEvidence,
  getPayContractLoan,
  getDynamicUrl,
  newYhConstract,
  loanAgreementParms,
  getAgreementsByCommodities,
};

export default ContractApi;
